import React, { useMemo, useState } from 'react';

const normalizeText = (value) => String(value || '').trim().toLowerCase();

const PosSlotPickerModal = ({
  isOpen,
  onClose,
  entries = [],
  onSelect,
}) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredEntries = useMemo(() => {
    const normalizedSearch = normalizeText(searchTerm);
    if (!normalizedSearch) return entries;
    return (entries || []).filter((entry) => (
      [
        entry?.productName,
        entry?.detailLabel,
      ].some((value) => normalizeText(value).includes(normalizedSearch))
    ));
  }, [entries, searchTerm]);

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-40 flex items-start justify-center bg-black/50 px-4 py-6"
      onClick={onClose}
    >
      <div
        className="w-full max-w-3xl rounded-2xl border border-gray-100 bg-white shadow-2xl"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="flex items-start justify-between border-b border-gray-100 bg-gray-50 px-6 py-4">
          <div>
            <div className="text-xs font-semibold uppercase tracking-wide text-gray-500">POS favs</div>
            <h2 className="mt-1 text-lg font-semibold text-gray-900">Agregar producto favorito</h2>
            <p className="mt-1 text-xs text-gray-500">
              Selecciona un producto para agregarlo al layout de favs.
            </p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="flex h-9 w-9 items-center justify-center rounded-full border border-gray-200 bg-white text-gray-600 hover:text-gray-900"
          >
            ✕
          </button>
        </div>

        <div className="space-y-4 p-6">
          <input
            type="text"
            value={searchTerm}
            onChange={(event) => setSearchTerm(event.target.value)}
            placeholder="Buscar producto..."
            className="w-full rounded-lg border border-gray-300 px-3 py-2.5 text-sm focus:ring-2 focus:ring-blue-500"
          />

          <div className="max-h-[60vh] overflow-y-auto">
            <div className="grid grid-cols-3 gap-3 sm:grid-cols-4 md:grid-cols-5 lg:grid-cols-6">
              {filteredEntries.length ? filteredEntries.map((entry) => (
                <button
                  key={entry.key}
                  type="button"
                  onClick={() => {
                    onSelect?.(entry);
                    setSearchTerm('');
                  }}
                  className={`flex aspect-square flex-col items-center justify-center overflow-hidden rounded-2xl border p-3 text-center shadow-sm transition ${
                    entry.soldOut
                      ? 'cursor-not-allowed border-gray-200 bg-gray-50 text-gray-400 opacity-80 grayscale'
                      : 'border-gray-200 bg-white hover:border-blue-300 hover:shadow-md'
                  }`}
                  disabled={entry.soldOut}
                  title={entry.productName}
                >
                  <img
                    src={entry.imageSrc || 'https://placehold.co/200'}
                    alt={entry.productName}
                    className="h-16 w-16 rounded-2xl object-cover shadow-sm"
                  />
                  <div
                    className="mt-3 w-full overflow-hidden px-1 text-center text-xs font-semibold leading-tight text-gray-900"
                    style={{
                      display: '-webkit-box',
                      WebkitBoxOrient: 'vertical',
                      WebkitLineClamp: 2,
                    }}
                  >
                    {entry.productName}
                  </div>
                </button>
              )) : (
                <div className="col-span-full rounded-2xl border border-dashed border-gray-300 bg-gray-50 px-6 py-10 text-center text-sm text-gray-500">
                  No hay productos que coincidan con la búsqueda.
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PosSlotPickerModal;
